import { Component, Input } from '@angular/core';
import { PartnerProfileComponent } from 'app/partner';

@Component({
    selector: 'partner-profile-security-tab',
    templateUrl: './partner-profile-security-tab.component.html',
    styleUrls: ['./partner-profile-security-tab.component.scss']
})
export class PartnerProfileSecurityTabComponent {
    @Input()
    public parent!: PartnerProfileComponent;
}
